import { IAppState } from 'src/app/redux/store/reducers';

export const isTimeBlockExpired = (state: IAppState): boolean =>
  !!state.sessionWizard.allocatedTimeBlock && state.sessionWizard.allocatedTimeBlock.expired;
